var _defs, _path, _path2, _path3, _circle, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_e78167896c3a3259f3d7b9bdad65e8fa0b50e409b37b5b271cf9644588f57772",
    x1: 85.282,
    y1: 33.949,
    x2: 114.174,
    y2: 33.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_e78167896c3a3259f3d7b9bdad65e8fa0b50e409b37b5b271cf9644588f57772",
    x1: 96.137,
    y1: 22.577,
    x2: 103.432,
    y2: 22.577,
    xlinkHref: "#SVGID_0_e78167896c3a3259f3d7b9bdad65e8fa0b50e409b37b5b271cf9644588f57772"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_e78167896c3a3259f3d7b9bdad65e8fa0b50e409b37b5b271cf9644588f57772",
    x1: 80.601,
    y1: 31.521,
    x2: 119.125,
    y2: 31.521,
    xlinkHref: "#SVGID_0_e78167896c3a3259f3d7b9bdad65e8fa0b50e409b37b5b271cf9644588f57772"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M53.551 59.865h91.32v67.304h-91.32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M117.875 43.937h11.078l15.921 15.929H53.551l15.921-15.929h12.379"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M86.532 52.008l.01-11.643-.01-18.742v-.177a5.554 5.554 0 005.556-5.556h15.271a5.551 5.551 0 005.556 5.545v.01l.01 18.919-.01 11.643",
    stroke: "url(#SVGID_0_e78167896c3a3259f3d7b9bdad65e8fa0b50e409b37b5b271cf9644588f57772)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_gradient",
    cx: 99.785,
    cy: 22.577,
    r: 2.398,
    stroke: "url(#SVGID_0_e78167896c3a3259f3d7b9bdad65e8fa0b50e409b37b5b271cf9644588f57772)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_e78167896c3a3259f3d7b9bdad65e8fa0b50e409b37b5b271cf9644588f57772)",
    d: "M117.875 52.008V11.033H81.851v40.975"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M73.772 52.011h51.325M122.835 96.366l-21.507 21.516-21.516-21.516c-5.941-5.941-5.941-15.574 0-21.507 5.941-5.941 15.575-5.941 21.516 0 5.941-5.941 15.566-5.941 21.507 0 5.942 5.933 5.942 15.566 0 21.507z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M105.934 88.729s-.817-4.726-4.726-4.726-4.96 4.726-4.96 4.726l10.153 7.698M96.714 96.427s.817 4.726 4.726 4.726 4.96-4.726 4.96-4.726M101.324 79.977v4.026M101.324 101.153v4.026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrant);
export default __webpack_public_path__ + "static/media/grant.966b630dd3f501a558580f5c74290ad7.svg";
export { ForwardRef as ReactComponent };